export interface IDateInput {
  year: number;
  month: number;
  day: number;
}
